var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scroll",staticClass:"v-stack v-start scroll-y h-stretch"},_vm._l((_vm.data),function(item){return _c('div',{key:item,staticClass:"calendardatapicker-item",class:[item == _vm.selectedItem ? 'calendardatapicker-selected' : ''],on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }